"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = exports.SubscriptionSuccessRequest = exports.CheckoutData = exports.CustomerManagementPortalRequest = exports.CheckoutRequest = exports.ProductType = exports.ProductTypeEnum = exports.CurrencyAmount = exports.Interval = exports.CustomerId = void 0;
const z = require("zod");
const UtilTypes_1 = require("./UtilTypes");
exports.CustomerId = UtilTypes_1.NumberString;
exports.Interval = z.object({
    number: z.number(),
    unit: z.string(),
});
exports.CurrencyAmount = z.object({
    currency: z.string(),
    amount: z.number(),
});
var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["Subscription"] = "subscription";
    ProductTypeEnum["Payment"] = "payment";
    ProductTypeEnum["All"] = "all";
})(ProductTypeEnum = exports.ProductTypeEnum || (exports.ProductTypeEnum = {}));
exports.ProductType = z.nativeEnum(ProductTypeEnum);
exports.CheckoutRequest = z.object({
    marketId: z.string(),
    successUrl: z.string(),
    cancelUrl: z.string(),
    productIds: z.string().array(),
    type: exports.ProductType,
});
exports.CustomerManagementPortalRequest = z.object({
    returnUrl: z.string(),
});
exports.CheckoutData = z.intersection(exports.CheckoutRequest, z.object({
    memberId: z.string(),
    customerId: UtilTypes_1.NumberString,
}));
exports.SubscriptionSuccessRequest = z.object({
    productIds: z.string().array(),
});
exports.Product = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    price: exports.CurrencyAmount,
    interval: exports.Interval.nullable(),
});
